/**
 * Registre central des endpoints — RÉ-EXPORT uniquement.
 *
 * La source canonique de chaque domaine vit dans sa feature
 * (`@/features/<f>/api/endpoints.ts`) : architecture modulaire, une feature =
 * un dossier auto-contenu. Ne JAMAIS définir de path ici ; ajouter la route
 * dans la feature puis la ré-exporter ci-dessous.
 */
import { authEndpoints } from "@/features/auth/api/endpoints";
import { kycEndpoints } from "@/features/kyc/api/endpoints";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import { payrollEndpoints } from "@/features/payroll/api/endpoints";
import { merchantEndpoints } from "@/features/merchant/api/endpoints";
import { feeEngineEndpoints } from "@/features/fee-engine/api/endpoints";
import { notificationEndpoints } from "@/features/notification/api/endpoints";
import { fundraisingEndpoints } from "@/features/fundraising/api/endpoints";
import { sharedEndpoints } from "@/features/shared/api/endpoints";
// Phase 6 — Comptabilité (ledger)
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
// Phase 8 — Administration & maker-checker
import { adminEndpoints } from "@/features/admin/api/endpoints";
// Phase 11 — Reporting fédéré (guide §7)
import { reportingEndpoints } from "@/features/reporting/api/endpoints";
// Phase 18 — Coffres d'épargne (savings-service, guide v3.1 §6.10)
import { savingsEndpoints } from "@/features/savings/api/endpoints";

export const endpoints = {
  auth: authEndpoints,
  kyc: kycEndpoints,
  wallet: walletEndpoints,
  payroll: payrollEndpoints,
  merchant: merchantEndpoints,
  feeEngine: feeEngineEndpoints,
  notification: notificationEndpoints,
  fundraising: fundraisingEndpoints,
  shared: sharedEndpoints,
  // Phase 6 — Comptabilité (ledger)
  ledger: ledgerEndpoints,
  // Phase 8 — Administration & maker-checker
  admin: adminEndpoints,
  // Phase 11 — Reporting fédéré
  reporting: reportingEndpoints,
  // Phase 18 — Coffres d'épargne (savings-service)
  savings: savingsEndpoints,
} as const;
